module.exports = __webpack_public_path__ + "img/1F496.a379c2e9.svg";